import {Badge} from "@mantine/core";
import {UsageEvent} from "../types.ts";

// FNP-536: the "did this event bill?" signal — the single most useful operator view of
// a raw UsageEvent. A row is BILLABLE only when both flags are clear (the FNP-215
// invariant: customerMeterKey is stamped, the aggregator will pick it up). Otherwise it
// is stuck at the front of the pipeline:
//   unresolvedCustomer -> who-pays unknown (awaiting R1 backfill)
//   unmetered          -> meterCode not in the catalog
export const BillableBadge = ({record}: { record: Pick<UsageEvent, 'unresolvedCustomer' | 'unmetered'> }) => {
    if (record.unresolvedCustomer) {
        return <Badge color={'orange'}>Unresolved customer</Badge>;
    }
    if (record.unmetered) {
        return <Badge color={'yellow'}>Unmetered</Badge>;
    }
    return <Badge color={'green'}>Billable</Badge>;
};
